import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import storage from "../firebase.config";
import { driverSelector, fetchOnedriver, updatedriver } from "../../api/driver";

import { keyUri } from "../../key";
import axios from "axios";

export default function DriverDocuments() {
  const dispatch = useDispatch();
  const { current_driver } = useSelector(driverSelector);
const [uploadedFiles, setUploadedFiles] = React.useState({});
const fileInputRefs = React.useRef({});

  const driver_id_ = localStorage.getItem("Driver");

    const uploadFile = async (file) => {
      try {
        const storageRef = ref(storage, `Driver-Documents/${file.name}`);
        await uploadBytes(storageRef, file);
        return await getDownloadURL(storageRef);
      } catch (error) {
        console.error("Upload failed:", error);
        throw new Error("License upload failed");
      }
    };

  useEffect(() => {
    if (driver_id_) {
      dispatch(fetchOnedriver(driver_id_));
    } else {
      console.warn("No driver ID found in localStorage.");
    }
  }, [dispatch, driver_id_]);

  const documents = [
    {
      title: "Driving License",
      key: "Driver_licence_link",
      src: current_driver?.Driver_licence_link,
      field: "Driver_licence_link",
    },
    {
      title: "Aadhar Card",
      key: "Driver_aadhar_link",
      src: current_driver?.Driver_aadhar_link,
      field: "Driver_aadhar_link",
    },
    
   
  ];

  const handleView = (url, title) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      alert(`No ${title} found.`);
    }
  };

  const handleFileChange = async (e, field) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    // upload to Firebase
    const url = await uploadFile(file, "Driver-Documents");

await dispatch(updatedriver(
  { [field]: url },   // values object
  current_driver._id  // id as second param
));

 // Clear the file input so filename disappears immediately
    if (fileInputRefs.current[field]) {
      fileInputRefs.current[field].value = "";
    }
// Refetch updated driver data to refresh UI immediately
 // Optimistically update local state for immediate UI change
    setUploadedFiles(prev => ({ ...prev, [field]: url }));

    await dispatch(fetchOnedriver(current_driver._id));
    
    alert(`${field} uploaded successfully!`);
        await dispatch(fetchOnedriver(current_driver._id));
  } catch (err) {
    console.error("Upload error:", err);
    alert("Upload failed.");
  }
};
//const src = uploadedFiles[doc.field] || doc.src;

  return (
    <div className="max-w-2xl mx-auto px-4 mt-48 mb-16">
      <h1 className="text-2xl font-bold mb-6">Driver Documents</h1>
 {documents.map((doc, index) => {
        // Calculate src inside map
        const src = uploadedFiles[doc.field] || doc.src;

        return (
          <div key={index} className="bg-white shadow-md rounded-lg p-4 mb-6 border">
            <h2 className="text-lg font-semibold mb-2">{doc.title}</h2>

            {src ? (
              <>
                <img
                  src={src}
                  alt={doc.title}
                  className="w-64 h-40 object-cover rounded border"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
                <div className="flex gap-4 mt-3 mb-4">
                  <button
                    onClick={() => handleView(src, doc.title)}
                    className="bg-blue-500 text-white px-4 py-1 rounded"
                  >
                    View {doc.title}
                  </button>

                  <a
                    href={src}
                    download={`${doc.title}.pdf`}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-green-500 text-white px-4 py-1 rounded flex items-center justify-center"
                  >
                    Download
                  </a>
                </div>
              </>
            ) : (
              <p className="text-red-500 italic">
                No {doc.title.toLowerCase()} document available
              </p>
            )}

            <input
              type="file"
              accept=".pdf,image/*"
              ref={el => fileInputRefs.current[doc.field] = el}
              onChange={(e) => handleFileChange(e, doc.field)}
            />
          </div>
        );
      })}
    </div>
  );
}
